import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const PAYMENT_METHOD = ['weChatPay', 'alipay']
const BROSWER_TYPE = ['pcBrowser', 'mobileBroswer', 'weChatBrowser']

export const schema = Joi.object().keys({
	payment_method: Joi.string().valid(PAYMENT_METHOD).required(),
	browser_type: Joi.string().valid(BROSWER_TYPE).required(),
});

export default function posterOrderPay(orderNumber, params) {

  let validateResult = Joi.validate(params, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  let toServer = {
    ...params,
    payment_method: PAYMENT_METHOD.indexOf(params.payment_method),
    browser_type: BROSWER_TYPE.indexOf(params.browser_type),
  }

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/poster_order_pay/${orderNumber}/`,
		'method': 'POST',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token') })
		.then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/payment/posterOrderPay.js